import React, { useState } from 'react'
import styled from 'styled-components'
import InputText from '../../shared/input/new/InputText'
import Btn from '../../shared/button/Btn'
import { useSelector } from 'react-redux'
import InputSelectMultiple from '../../shared/input/new/InputSelectMultiple'
import { addNewPageOrMenu } from '../../../features/admin5/admin5Slice'
import { useDispatch } from 'react-redux'

const Container = styled.div`
    width: 45%;
    height: 100%;
    .title{
        font-size: var(--font-size-lg);
        font-weight: var(--font-weight-lg);
        margin-bottom: 20px;
        text-align: center;
    }
    .input-list{
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        gap: 10px;
        border: 2px solid ;
        border-color: ${({ theme }) => theme.mainBorderColor};
        padding: 20px;
        border-radius: 10px;
    }
`
// {
//     "name": "admin_create_page_action",
//     "description": "Sayfa Oluşturma",
//     "type": "permission",
//     "slug": "/admin/sayfa-olusturma",
//     "subLinkId": 18,
//     "roles": [
//       "EgeYurtAdmin",
//       "Admin"
//     ]
// }

const roleDatas = [
    {
        id: 1,
        value: "Admin",
        text: "Admin"
    },
    {
        id: 2,
        value: "EgeYurtAdmin",
        text: "Ege Yurt Admin"
    },
    {
        id: 3,
        value: "DigitalLogisticsAdmin",
        text: "Dijital Lojistikçi"
    },
    {
        id: 4,
        value: "CooperativeAdmin",
        text: "Kooperatif"
    },
    {
        id: 5,
        value: "ShipperAdmin",
        text: "Yük Veren"
    },
    {
        id: 6,
        value: "DigitalLogisticsShipperAdmin",
        text: "Dijitla Lojistikçinin Yük Vereni"
    }
]

const AdminMenuEkleInputContainer = () => {
    const { adminOrUserClaims } = useSelector((state) => state.companyAuthorization)
    const dispatch = useDispatch()

    const [selectedRole, setSelectedRole] = useState([])
    const [data, setData] = useState({
        name: "",
        description: "",
        slug: ""
    })

    const handleChange = (e) => {
        setData({
            ...data,
            [e.target.name]: e.target.value
        })
    }

    const handleSubmit = () => {
        if(data.name && data.description && data.slug){
            const addData = {
                name: data.name,
                description: data.description,
                type: "permission",
                slug: data.slug,
                subLinkId: adminOrUserClaims[adminOrUserClaims?.length - 1].id + 1,
                roles: selectedRole.map(item => item.value)
            }
            dispatch(addNewPageOrMenu(addData))
            setData({
                name: "",
                description: "",
                slug: "" 
            })
            setSelectedRole([])
        }
    }
    
  return (
    <Container>
       <p className='title'>Menü Bilgileri</p>
       <div className="input-list">
            <InputText data={data?.name} setData={(e) => handleChange(e)} name={"name"} labelText='Rol Adı' inputWidth={"100%"} />
            <InputText data={data?.description} setData={(e) => handleChange(e)} name={"description"} labelText='Menü Adı' inputWidth={"100%"} />
            <InputText data={data?.slug} setData={(e) => handleChange(e)} name={"slug"} labelText='Menü Uzantısı' inputWidth={"100%"} />
            <InputSelectMultiple data={selectedRole} setData={setSelectedRole} labelText='Rol Seçimi' name={"role"} inputWidth={"100%"} options={roleDatas} />
            <Btn width={"240px"} bgColor="transparent" color="#E85446" handleClick={handleSubmit} >Oluştur</Btn>
       </div>
    </Container>
  )
}

export default AdminMenuEkleInputContainer